module.exports = __webpack_public_path__ + "static/media/ic-lightbulb.a51e1322.svg";